import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose'
import { translate } from 'react-switch-lang'
import { Grid, List } from 'semantic-ui-react'
import { setError } from '../../../../redux/actions/actionsCallAPI'
import { getErrorList } from '../../../../redux/selectors/selectorCallAPI'
import AlertModal from '../modal/alertModal'

class ModalErrorNoSuccess extends React.Component {
    constructor(props) {
        super(props)
        this.state = {

        }
    }

    render() {
        const { errorList } = this.props
        
        let openModal = false
            , mapErrorList = []
        if (errorList && Array.isArray(errorList) && errorList.length > 0) {
            const findeError = errorList.find(e => e.isShow === true)
            if (!findeError) {
                openModal = true
            }
            mapErrorList = errorList
        }

        return (
            <React.Fragment>
                <AlertModal
                    type="error"
                    open={openModal}
                    size={"tiny"}
                    close={() => this.props.setError(errorList, null, true)}
                    // header={textHeaderModal}
                    content={
                        <div className="">
                            <List divided relaxed>
                                {
                                    mapErrorList.map((d, i) => {
                                        return <List.Item key={i}>
                                            <Grid>
                                                <Grid.Row >
                                                    <Grid.Column width={16}>
                                                        <p>{d.statusCode} {d.statusText}</p>
                                                    </Grid.Column>
                                                </Grid.Row>
                                            </Grid>
                                        </List.Item>
                                    })
                                }
                            </List>
                        </div>
                    }
                    actions={[
                        { text: "Close", className: "btn cancel", action: () => this.props.setError(errorList, null, true) }
                    ]}
                />
            </React.Fragment>
        )
    }
}

export default compose(
    withRouter,
    translate,
    connect(
        (state, props) => ({
            errorList: getErrorList(state)
        }),
        (dispatch, { history }) => ({
            setError(errorList, newError, isShow) {
                dispatch(setError(errorList, newError, isShow))
            }
        })
    ),
    lifecycle({
        componentDidMount() {
            // this.props.setError(this.errorList, { code: '000000', message: '000000' }, false)
        }
    }),
)(ModalErrorNoSuccess)


// WEBPACK FOOTER //
// ./src/app/components/features/share/modal/modalErrorNoSuccess.js